import { Badge, badgeClasses } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
    count: number
    showZero?: boolean
}>

export const NotificationsBadge: FC<Props> = ({ count, children, showZero = true, disabled }) => {
    const hasNotifications = !!count

    return (
        <Badge
            badgeContent={count}
            showZero={showZero}
            color="error"
            variant={hasNotifications ? 'standard' : 'dot'}
            sx={{
                [`.${badgeClasses.badge}`]: {
                    opacity: disabled? '0.5' : '1',
                    border: '1px solid #FFFFFF',
                    p: 0,
                    fontSize: '10px',
                    minWidth: hasNotifications ? '16px' : '6px',
                    height: hasNotifications ? '16px' : '6px',
                    transform: hasNotifications
                        ? 'scale(1) translate(25%, -25%)'
                        : 'scale(1) translate(-20%, 20%)',
                },
            }}>
            {children}
        </Badge>
    )
}
